package one.healthium.cali.presentation.navigation.root

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

class PaywallController {

    private val _paywallState = MutableStateFlow(false)
    val isActive = _paywallState.asStateFlow()

    internal fun setActive(active: Boolean) {
        _paywallState.value = active
    }
}